const addMes = {
    path: 'mesAdd',
    component: resolve => require(['@/pages/admin/message/mes-handle.vue'], resolve)
}

export default addMes